import { JSX } from 'react';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';

type azSearchResultProps = {
  card: {
    clickUri: string;
    cwtitle: string;
    cwdescription: string;
    cwformat: string | string[];
    cwauthorname?: string;
    cwauthortitle?: string;
    cwcontentdate?: string;
    controller?: {
      select?: () => void;
    };
  };
};

const AZResultCard = ({ card }: azSearchResultProps): JSX.Element => {
  const {
    clickUri,
    cwtitle,
    cwdescription,
    cwformat: format,
    cwauthorname,
    cwauthortitle,
    cwcontentdate,
    controller: controller,
  } = card;
  // normalize author and title
  const authorName = (cwauthorname || '').trim();
  const authorRole = (cwauthortitle || '').trim();
  return (
    <>
      <article
        role="region"
        aria-labelledby={`${cwtitle}`}
        className="lg:flex-row flex-col-reverse flex py-[30px] border-b border-b-gray-50 last:border-0 lg:gap-[46px] gap-[24px] justify-between"
      >
        {/* content section */}
        <div className="w-full">
          <div className="flex flex-col w-full justify-between">
            {/* format + date responsive layout */}
            <div className="flex flex-col lg:flex-row lg:justify-between w-full">
              {/* FORMAT (always left on desktop) */}
              <PlainTextWrapper
                field={{ value: Array.isArray(format) ? format.join(', ') : format || '' }}
                tag="p"
                className="text-14 leading-22 font-centuryGothic font-bold text-gray-500"
              />

              {/* DATE (under format on mobile, right-aligned on desktop) */}
              <PlainTextWrapper
                field={{
                  value: Array.isArray(cwcontentdate)
                    ? cwcontentdate.join(', ')
                    : cwcontentdate || '',
                }}
                tag="p"
                className="text-14 leading-22 font-centuryGothic font-bold text-gray-500 lg:text-right"
              />
            </div>
            <a
              aria-label={`${cwtitle}`}
              title={cwtitle}
              href={clickUri}
              onClick={() => controller?.select?.()}
              onMouseDown={() => controller?.select?.()}
              className="block"
            >
              <h2 className="text-blue-base text-28 leading-[34px] font-bold font-centuryGothic pb-2 my-6 hover:underline hover:text-darkblue-base cursor-pointer lg:line-clamp-1 line-clamp-2 overflow-hidden hover:overflow-visible hover:line-clamp-none">
                <PlainTextWrapper field={{ value: cwtitle || '' }} />
              </h2>
            </a>
            <div className="text-gray-900 font-nunitoSans text-16 leading-25 font-[500]">
              {/* apply line-clamp to a wrapper div so the generated inner HTML from RichTextWrapper is clipped */}
              <div className="line-clamp-4 lg:line-clamp-3 overflow-hidden hover:overflow-visible hover:line-clamp-none">
                <RichTextWrapper
                  field={{
                    value: cwdescription,
                  }}
                />
              </div>
            </div>
            {/* optionally add author and author title here separated by a pipe if author exists */}
            {authorName && (
              <p className="mt-3 text-14 leading-20 text-gray-600">
                <PlainTextWrapper
                  field={{ value: authorName }}
                  tag="span"
                  className="font-semibold"
                />
                {authorRole && (
                  <>
                    <span className="mx-2 text-gray-400">|</span>
                    <PlainTextWrapper field={{ value: authorRole }} tag="span" />
                  </>
                )}
              </p>
            )}
          </div>
        </div>
        {/* end content section */}
      </article>
    </>
  );
};

export default AZResultCard;
